define.alias("ember-math-helpers/helpers/trunc", "settings/helpers/trunc");